package com.milta.core.localization.translations.ro

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "IA",
    menuAiLegend = "IA: citire automată prin inteligență artificială, care folosește creditul IA. Pentru Excel, doar dacă coloanele nu sunt recunoscute.",
    menuExhaustedTitle = "Credit IA epuizat — resetare pe {date}.",
    menuExhaustedMessage = "Scanarea și importul PDF sunt dezactivate. Un tabel cu coloanele așteptate și introducerea manuală rămân disponibile.",
    modeDisabledReason = "Credit IA epuizat",
    exhaustedBannerWebTitle = "Credit IA epuizat — resetare pe {date}.",
    exhaustedBannerWebMessage = "Fișierele PDF nu mai pot fi analizate. Importați un fișier Excel sau CSV cu coloanele așteptate sau adăugați livrările manual din aplicația mobilă.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) sau CSV · max. 500 de opriri · 10 MB",
    pdfUnavailableUntil = "PDF indisponibil până pe {date}",
    pdfRefusedTitle = "Credit IA epuizat — acest PDF nu poate fi analizat",
    pdfRefusedMessage = "„{file}” necesită citire de către IA. Creditul revine pe {date}. Până atunci, importați un fișier Excel sau CSV cu coloanele așteptate sau adăugați livrările manual din aplicația mobilă.",
    spreadsheetExhaustedTitle = "Coloane nerecunoscute — credit IA epuizat",
    spreadsheetExhaustedWebMessage = "Coloanele din „{file}” nu corespund coloanelor așteptate, iar creditul IA nu mai permite identificarea lor automată (revine pe {date}). Redenumiți coloanele ca mai jos sau adăugați livrările manual din aplicația mobilă.",
    expectedColumnsNoCreditHint = "Un fișier care respectă aceste coloane este importat fără IA și nu consumă credit, chiar și la 0%.",
    importExhaustedTitle = "Credit IA epuizat",
    importExhaustedPhotoMessage = "Creditul IA a ajuns la 0% în timp ce acest import aștepta. Fotografia nu a fost analizată și nu s-a contorizat nimic. Resetare pe {date}.",
    importExhaustedFileMessage = "Creditul IA a ajuns la 0% în timp ce acest import aștepta. Fișierul nu a fost analizat și nu s-a contorizat nimic. Resetare pe {date}.",
    importSpreadsheetExhaustedMessage = "Coloanele acestui fișier nu corespund coloanelor așteptate, iar creditul IA nu mai permite identificarea lor automată. Resetare pe {date}.",
    stepPhotoSent = "Fotografie trimisă",
    stepFileSent = "Fișier trimis: {file}",
    stepAnalysisNotStarted = "Analiză nepornită: credit IA epuizat",
    stepFileRead = "Fișier citit: {file}",
    stepExpectedColumns = "Coloane așteptate: Numele destinatarului, Adresa completă",
    stepDeliveriesKept = "Livrările deja introduse sunt păstrate",
    retryAvailableOn = "Reîncercați — disponibil pe {date}",
    manualEntryAction = "Introducere manuală",
    myUsageTitle = "Utilizarea mea",
    myUsageAttachedDriverNote = "Aici apar doar propriile dumneavoastră acțiuni. Ce lansează companiile pentru dumneavoastră este contabilizat la ele.",
    tabOptimizations = "Optimizări",
    tabAiCredit = "Credit IA",
    remainingForPeriod = "Credit IA rămas pentru perioadă",
    percentValue = "{percent}%",
    remainingSuffix = "credit IA rămas",
    lowPill = "Credit scăzut",
    exhaustedPill = "Epuizat · scanare și import PDF dezactivate",
    driverNote = "Creditul revine la reînnoirea abonamentului (al Întreprinderii dvs., dacă faceți parte din una). Creditul neutilizat nu se reportează.",
    enterpriseNote = "Revine la reînnoirea abonamentului, fără report. Acest credit privește doar acțiunile dvs. IA; fiecare șofer are propriul credit.",
    exhaustedNote = "Introducerea manuală și tabelele cu coloanele așteptate rămân disponibile. Creditul revine la reînnoirea abonamentului.",
    webScopeHint = "Acest credit privește doar acțiunile IA ale acestui cont: scanări, importuri PDF sau foto, coloane de tabel nerecunoscute. Fiecare șofer are propriul credit.",
    profileValue = "{optimizations} · IA {percent}%",
    profileValueAiOnly = "IA {percent}%",
    columnShare = "Parte din credit",
    actionScanDeliveryList = "Scanare listă",
    actionScanPackageLabel = "Scanare etichetă",
    actionImportPdf = "Import PDF",
    actionImportUnstructured = "Import în fundal",
    actionSpreadsheetMapping = "Coloane de tabel (IA)",
    outcomeSuccess = "Reușit",
    outcomeFailed = "Eșuat",
    outcomeUnreadable = "Ilizibil",
    countedSuffix = "(contorizat)",
    rowDateTime = "{date} la {time}",
    limitsEyebrow = "Credit IA pe perioadă",
    limitsDescription = "Suma în euro pe care fiecare cont o poate consuma pe apeluri IA (scanări, importuri PDF sau foto, coloane de tabel nerecunoscute) pe perioadă de abonament. Creditul revine la limită la reînnoirea abonamentului, fără report.",
    weightedEquivalent = "≈ {tokens} tokenuri ponderate",
    limitsFootnote = "Un șofer al unei Întreprinderi primește limita „Șofer”, de probă cât timp Întreprinderea sa este în probă. Echivalentul în tokenuri este afișat cu titlu orientativ și se recalculează cu cursul de mai jos.",
    conversionEyebrow = "Conversie și alertă",
    rateLabel = "Curs de schimb",
    rateHint = "Actualizat manual · se aplică apelurilor următoare",
    thresholdLabel = "Alertă credit scăzut",
    thresholdUnit = "% rămas",
    thresholdHint = "Procent afișat în portocaliu și banner o dată pe perioadă",
    calculationTitle = "Cum se calculează costul unui apel.",
    calculationBody = "Claude Haiku 4.5: 1 $ per milion de tokenuri de intrare, 5 $ per milion de tokenuri de ieșire. Token ponderat = intrare × 1 + ieșire × 5, deci 1 $ = 1.000.000 de tokenuri ponderate. Cost în euro = cost în dolari ÷ curs. Exemplu: o scanare de listă medie (5.014 intrare + 1.792 ieșire) = 13.974 de tokenuri ponderate = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Limite salvate.",
    settingsSavedDetail = "Întreprindere: {enterpriseTrial} probă · {enterprisePaid} plătit. Șofer: {driverTrial} probă · {driverPaid} plătit. Curs {rate}. Alertă {threshold}%.",
    limitTooHigh = "Maximum 1.000 €.",
    rateTooHigh = "Maximum 10.",
    thresholdOutOfRange = "Între 1 și 99.",
    adminCreditTitle = "Credit IA",
    adminRemainingLine = "≈ {tokens} tokenuri ponderate rămase · consumat {consumed}",
    adminOverrunLine = "Consumat {consumed} · depășire de {over}",
    adminLowPill = "Credit scăzut · sub {threshold}%",
    adminLowPillNoThreshold = "Credit scăzut",
    adminExhaustedPill = "Credit epuizat · acțiuni IA dezactivate",
    adminAppliedAfterReplacement = "{consumed} consumat + {remaining} rămas (înlocuire)",
    adminGlobalLimitLabel = "Limită globală",
    adminGlobalLimitResumes = "{source} — se aplică din nou la resetare",
    adminResetNoCarryOver = "Repornește de la {limit}: depășirea nu se reportează",
    replaceLabel = "Înlocuiți creditul rămas",
    replaceHelp = "Între 0 și 100 €, doar pentru perioada curentă. La resetare, contul pornește din nou de la limita globală.",
    replaceHelpEnterpriseDriver = "Modifică doar creditul lui {name}. Cel al Întreprinderii și al celorlalți șoferi nu se schimbă.",
    replaceInvalid = "Introduceți o sumă între 0 și 100 €.",
    replacedTitle = "Credit rămas înlocuit: {from} → {to}.",
    replacedDetail = "Pentru perioada curentă. Pe {date}, revenire la limita globală ({limit}).",
    adminHistoryTitle = "Istoricul creditului IA",
    adminPeriodSummary = "Perioada curentă din {start}: {calls} apeluri · {failed} eșuate sau ilizibile (contorizate) · {tokens} tokenuri ponderate · {consumed}",
    columnInput = "Intrare",
    columnOutput = "Ieșire",
    columnWeighted = "Ponderate",
    columnCost = "Cost",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Creditul IA este epuizat. Fișierul nu a fost analizat și nu s-a contorizat nimic. Resetare pe {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
